import React, { useEffect, useState } from "react";
import HomePostingList from "./HomePostingList";
import "../styles/Homepage.css";

import { Link } from "react-router-dom";

const Homepage_Post = ({ doRefreshPosts, appRefresh, filteredPosts, suggestedDishes, follow, late, good,bad, you}) => {
  const [posts, setPosts] = useState([]);
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [userToken, setUserToken] = useState("");
  const blockedContent = sessionStorage.getItem("blockedPosts");
  
  
const [aPost, setAPosts] = useState([]); 
  const userId = sessionStorage.getItem("user");
  const [avg, setAvg] = useState([]);
  const [dishesData, setDishesData] = useState(null);
  const [customMessage, setCustomMessage] =useState("");
const [filter, setFilter]= useState([]);
  useEffect(() => {
    setUserToken(sessionStorage.getItem("token"));
    LoadOnlyPosts();
  }, []);

 


  useEffect(() => {
    if (filteredPosts) {
      setPosts(filteredPosts);
      setIsLoaded(true);
    }
    
  }, [filteredPosts]);

  useEffect(() => {
    if (!userToken) {
      console.warn("User not logged in. Aborting user data fetch.");
      return;
    }
  
    const fetchUserData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_PATH}/users/${userId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userToken}`,
            },
          }
        );
  
        const result = await response.json();
        console.log("User data fetched:", result);
  
        if (result && result.attributes) {
          setFilter(result.attributes.filter || []);
        } else {
          console.error("Unexpected user data structure:", result);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        
      }
    };
  
    fetchUserData();
  }, [userToken, userId]);
 
  
 useEffect(() => {
    setUserToken(sessionStorage.getItem("token"));
    
    // Load dishes data
    const loadDishesData = async () => {
      try {
        const dishes = await import('../assets/dishes2.json');
        setDishesData(dishes.default);
      } catch (error) {
        console.error("Error loading dishes data:", error);
      }
    };
    
    loadDishesData();
  }, []);

  useEffect(() => {
    const loadFollowOnlyPosts = async () => {
      try {
        const allPosts = await fetchAllPosts();
        if (!allPosts || allPosts.length === 0) {
          setCustomMessage("Whoah your our first customer! Make some posts and we'll sort them!"); 
          return; 
        }
       
        const followedUserIDs = await fetchFollowedUserIDs();
        if (!followedUserIDs || followedUserIDs.length === 0) {
       
          setCustomMessage("Whoops it empty! Make some friends then come back here to see their posts!"); 
          return; // Exit early
        }
        const followedPosts = allPosts.filter(post =>
          followedUserIDs.includes(post.authorID)
        );
  
        setPosts(followedPosts);
        setCustomMessage("");
      } catch (err) {
        console.error("Error loading followed posts only:", err);
        setError(err);
      } finally {
        setIsLoaded(true);
      }
    };

    const loadBestPosts = async () => {
      try {
        const allPosts = await fetchAllPosts();
        if (!allPosts || allPosts.length === 0) {
          setCustomMessage("Whoah your our first customer! Make some posts and we'll sort them!"); 
          return; 
        }
       
      
        const filtered = allPosts.filter(
          post => post.attributes && typeof post.attributes.overallRating === 'number'
        );
    
        const sorted = filtered.sort(
          (a, b) => b.attributes.overallRating - a.attributes.overallRating
        );
    
        setPosts(sorted);
        setCustomMessage("");
      } catch (err) {
        console.error("Error loading best posts:", err);
        setError(err);
      } finally {
        setIsLoaded(true);
      }
    };

    const loadFilteredPostsByTags = async () => {
      if (!filter || filter.length === 0) {
        setCustomMessage("Oops! We don't know much about you to show your own feed, go to settings and edit your food choices and come back here!");
        return;
      }
  
      try {
        // Fetch all posts
        const token = sessionStorage.getItem("token");
        const response = await fetch(`${process.env.REACT_APP_API_PATH}/posts?parentID=`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
        });
  
        if (!response.ok) {
          throw new Error(`Failed to fetch posts: ${response.status} ${response.statusText}`);
        }
  
        const result = await response.json();
        const posts = result[0] || [];
  
        // Process posts to add dishTags from dishes2.json if necessary
        const processedPosts = await Promise.all(
          posts.map(async (post) => {
            if (post.attributes?.dishID && dishesData) {
              const matchingDish = dishesData.find(dish => dish.id === Number(post.attributes.dishID));
              return {
                ...post,
                dishTags: matchingDish?.tags || [],
              };
            }
            return {
              ...post,
              dishTags: [],
            };
          })
        );
  
        // Now filter the posts with the user filter data
        const lowerCaseFilters = filter.map(f => f.toLowerCase());
  
        const filteredPosts = processedPosts.filter(post => {
          return lowerCaseFilters.some(filter => {
            const isWholeWordMatch = (text, searchWord) => {
              if (!text) return false;
              const words = text.toLowerCase().split(/\s+/);
              return words.includes(searchWord);
            };
  
            // Check if any of the post's attributes match the filter
            const contentMatch =
              isWholeWordMatch(post.content, filter) ||
              isWholeWordMatch(post.attributes?.title, filter);
  
            const tagMatch = (post.attributes?.tags || []).some(tag => tag.toLowerCase() === filter);
            const dishTagMatch = (post.dishTags || []).some(tag => tag.toLowerCase() === filter);
  
            return contentMatch || tagMatch || dishTagMatch;
          });
        });
  
        // Update state with the filtered posts
        setPosts(filteredPosts);
  
        // If no posts match the filter, show a message
        if (filteredPosts.length === 0) {
          setCustomMessage("Look's no one posted about your choices, lets change that by making some posts with dishes about them");
        } else {
          setCustomMessage(""); // Clear message if posts are found
        }
      } catch (error) {
        console.error("Error filtering posts by user filters:", error);
        setError(error);
        setCustomMessage("Error filtering posts. Please try again.");
      }
    };
  


    
    const loadWorstPosts = async () => {
      try {
        const allPosts = await fetchAllPosts();
        if (!allPosts || allPosts.length === 0) {
          setCustomMessage("Whoah your our first customer! Make some posts and we'll sort them!"); 
          return; 
        }
        const filtered = allPosts.filter(
          post => post.attributes && typeof post.attributes.overallRating === 'number'
        );
    
        const sorted = filtered.sort(
          (a, b) => a.attributes.overallRating - b.attributes.overallRating
        );
    
        setPosts(sorted);
        setCustomMessage("");
      } catch (err) {
        console.error("Error loading worst posts:", err);
        setError(err);
      } finally {
        setIsLoaded(true);
      }
    };
  
    const loadAllPosts = async () => {
      try {
        const allPosts = await fetchAllPosts();
        if (!allPosts || allPosts.length === 0) {
          setCustomMessage("Whoah your our first customer! Make some posts to fill up our website"); 
          return; 
        }
        setPosts(allPosts);
        setCustomMessage(""); // Set all posts if `late` is true
      } catch (err) {
        console.error("Error loading all posts:", err);
        setError(err);
      } finally {
        setIsLoaded(true);
      }
    };
  
    if (late  && !filteredPosts) {
      loadAllPosts();
    } else if (follow && !filteredPosts) {
      loadFollowOnlyPosts();
    } else if (good && !filteredPosts) {
      loadBestPosts();
    } else if (bad && !filteredPosts) {
      loadWorstPosts();
    }
    else if (you && !filteredPosts) {
      loadFilteredPostsByTags(); // 👈 add this
    }
    
  }, [follow, late, good, bad,you, filteredPosts]);


  const fetchConnections = async () => {
    try {
      const token = sessionStorage.getItem("token");
  
      const [followingRes, followersRes] = await Promise.all([
        fetch(`${process.env.REACT_APP_API_PATH}/connections?fromUserID=${userId}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }),
        fetch(`${process.env.REACT_APP_API_PATH}/connections?toUserID=${userId}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }),
      ]);

     
     
  
      const [followingData, followersData] = await Promise.all([
        followingRes.json(),
        followersRes.json(),
      ]);
  
      const followingIDs = followingData[0].map((conn) => conn.toUserID);
      const followerIDs = followersData[0].map((conn) => conn.fromUserID);
  
      return { followingIDs, followerIDs };
    } catch (err) {
      console.error("Error fetching connections:", err);
      return { followingIDs: [], followerIDs: [] };
    }
  };

  const LoadOnlyPosts = async () => {
    try {
      const allPosts = await fetchAllPosts();
      setAPosts(allPosts); 
    }
    catch (err) {
      console.error("Error loading post", err);
      setError(err);
    }
    
  };

  const fetchFollowedUserIDs = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_PATH}/connections?fromUserID=${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (!res.ok) {
        console.error("Failed to fetch connections:", res.status);
        return [];
      }

      const result = await res.json();
      return result[0].map((conn) => conn.toUserID);
    } catch (err) {
      console.error("Error fetching connections:", err);
      return [];
    }
  };

  const fetchAllPosts = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_PATH}/posts?parentID=`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!res.ok) {
        throw new Error(`Failed to fetch posts: ${res.statusText}`);
      }

      const result = await res.json();
      return result[0] || [];
    } catch (err) {
      console.error("Error fetching posts:", err);
      throw err;
    }
  };

  const loadFollowedPosts = async () => {
    try {
      
      const allPosts = await fetchAllPosts();
      const {followingIDs, followerIDs} = await fetchConnections();

      const visiblePosts = allPosts.filter((post) => {
        const isPublic = !post.attributes?.private;
        const isMutualFollow = followingIDs.includes(post.authorID) && followerIDs.includes(post.authorID);
        const isSelf = String(post.authorID) === String(userId);
        return isPublic || isMutualFollow || isSelf;
      });

      setPosts(visiblePosts);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoaded(true);
    }
  };

  const loadUnfilteredPosts = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_PATH}/posts?parentID=`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(userToken && { Authorization: `Bearer ${userToken}` }),
        },
      });

      const result = await res.json();
      let posts = result[0] || [];


      setPosts(posts);
    } catch (err) {
      console.error("Error loading unfiltered posts:", err);
      setError(err);
    } finally {
      setIsLoaded(true);
    }
  };


const topDishes = avg
.sort((a, b) => b.average - a.average)  // Sort by average rating in descending order
.slice(0, 10); 

  useEffect(() => {
    const runInitialLoad = async () => {
      if (!filteredPosts) {
        await loadFollowedPosts();
      }
    };

    runInitialLoad();
  }, [filteredPosts]);

  return (
    
    <div>
      <br />
      
      {customMessage ? (
 <div class="no-posts-message"><h3>No Posts Found</h3><p>{customMessage}</p></div>
) : (
        <HomePostingList
          refresh={appRefresh}
          posts={posts}
          error={error}
          isLoaded={isLoaded}
          type="postlist"
          loadFollow={loadFollowedPosts}
          loadPosts={loadUnfilteredPosts}
          suggestedDishes={suggestedDishes}
          apost={aPost}
        />
      )}
      </div>
    
  );
};

export default Homepage_Post;

















// import React, { useEffect, useState } from "react";
// import HomePostingList from "./HomePostingList";
// import "../styles/Homepage.css";


// const Homepage_Post = ({ doRefreshPosts, appRefresh, filteredPosts, suggestedDishes }) => {
//   const [posts, setPosts] = useState([]);
//   const [error, setError] = useState(null);
//   const [isLoaded, setIsLoaded] = useState(false);
//   const [userToken, setUserToken] = useState("");
//   //const [userIds, setUserIds]= useState("");

//   const userId = sessionStorage.getItem("user");

//   useEffect(() => {
//     setUserToken(sessionStorage.getItem("token"));
//   }, []);

//   // When filteredPosts changes, update our posts state
//   useEffect(() => {
//     if (filteredPosts) {
//       setPosts(filteredPosts);
//       setIsLoaded(true);
//     }
//   }, [filteredPosts]);

//   //loading a list of all the poeple I follow:
//   const connectionsRes = async () => {
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_PATH}/connections?fromUserID=${userId}`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${sessionStorage.getItem("token")}`,
//           },
//         }
//       );

//       if (!response.ok) {
//         console.error("Failed to fetch connections:", response.status);
//         return []; // return empty array if fetch fails
//       }

//       const result = await response.json();

//       // Extract the user IDs of followed users
//       const userIds = result[0].map((user) => user.toUserID);

//       return userIds;

//     } catch (err) {
//       console.error("Error fetching connections:", err);
//       return []; // safe fallback
//     }
//   };

//   // load all the posts in the database to display on the screen in the home page
//   const loadFollow = async () => {

//     const userIds = await connectionsRes();
//     // if the user is not logged in, we don't want to try loading posts, because it will just error out.
//     //let url = process.env.REACT_APP_API_PATH + "/posts?parentID=";
//     let url = process.env.REACT_APP_API_PATH + "/posts";
//     // make an api request to fetch all the posts which are original posts (not comments/don't have a parentId)
//     fetch(url, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//       },
//     })
//       .then((res) => res.json())
//       .then((result) => {
//         if (result) {

//           //inside if statment filter to if it is a private post and i follow them
//           setPosts(result[0].filter((post) => !post.attributes?.private || userIds.includes(post.authorID) || userId == post.authorID));

//           setIsLoaded(true);
//         }
//       })
//       .catch((err) => {
//         setIsLoaded(true);
//         setError(err);
//       });

//   };

//   useEffect(() => {
//     // the first thing we do when the component is ready is load the posts.
//     loadFollow();
//   }, []);


//   const loadPosts = () => {
//     // Only load posts if we're not using filtered posts
//     if (filteredPosts === null) {
//       const token = sessionStorage.getItem("token");
//       let url = process.env.REACT_APP_API_PATH + "/posts?parentID=";


//       // make an api request to fetch all the posts which are original posts (not comments/don't have a parentId)
//       fetch(url, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           ...(token && { "Authorization": `Bearer ${token}` }) // Conditionally add token if available

//         },
//       }
//       )
//         .then((res) => {
//           if (!res.ok) {
//             console.warn(`API request returned ${res.status} ${res.statusText}`);
//             // Still try to parse the response as we might get valid data even with error
//           }
//           return res.json();
//         })
//         .then((result) => {
//           if (result && result[0]) {
//             setIsLoaded(true);
//             setPosts(result[0]);
//             console.log("Got Posts:", result[0].length);
//           } else {
//             setIsLoaded(true);
//             setPosts([]);
//             console.log("No posts found or invalid response format");
//           }
//         })
//         .catch((err) => {
//           setIsLoaded(true);
//           setError(err);
//           console.error("ERROR loading posts:", err);
//         });
//     }
//   };

//   useEffect(() => {
//     // Only load posts if we're not using filtered posts
//     if (filteredPosts === null) {
//       loadPosts();
//     }
//   }, [filteredPosts]);

//   return (
//     <div>
//       <br></br>
//       <div className="mainspace">
//         <HomePostingList
//           refresh={appRefresh}
//           posts={posts}
//           error={error}
//           isLoaded={isLoaded}
//           type="postlist"
//           loadFollow={loadFollow}
//           loadPosts={loadPosts}
//           suggestedDishes={suggestedDishes}
//         />
//       </div>
//     </div>
//   );
// };

// export default Homepage_Post;
